import React, {forwardRef} from "react";
import css from "./index.module.scss";

export default forwardRef(({
  headline = "",
  href = "",
  className = "",
  target = "_self",
  children,
  dark = false,
  icon = null,
}, ref) => {
  let thisClassName = `custom ${css.card} ${className}`;
  if (dark) {
    thisClassName += ` ${css.dark}`;
  }

  const content = <>
    {icon && <div className={css.icon}>{icon}</div>}
    {headline && <div className={css.cardHeadline}>{headline}</div>}
    <div className={css.cardBody}>
      {children}
    </div>
  </>;

  if (href){
    return <a
      className={thisClassName}
      href={href}
      target={target}
      ref={ref}
    >
      {content}
    </a>;
  }
  return <div className={thisClassName} ref={ref}>{content}</div>;
});
